import DOMPurify from 'dompurify';

import Alert from '@/components/ui/Alert';
import { t } from '@/lib/utils';
import { useUserStore } from '@/stores/userStore';

export const ActivationAlert = () => {
    const { account } = useUserStore();
    const shouldAlertOpen = account?.permissions?.includes('emsp-cards.write');

    return (
        <Alert
            className='margin-bottom-15'
            open={shouldAlertOpen}
            title={t('chargingCards.activationWarning.title')}
            content={
                <p
                    className='margin-bottom-0'
                    // biome-ignore lint: sanitized content with DOMPurify
                    dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(t('chargingCards.activationWarning.description')),
                    }}
                />
            }
        />
    );
};
